module.exports = __webpack_public_path__ + "static/img/PFK_OurTeam_Photo2_RettaJitnerHeadshot_240x215.b8576d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PFK_OurTeam_Photo2_RettaJitnerHeadshot_240x215.jpg
// module id = 329
// module chunks = 2